
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductBooksGrid extends Serenity.EntityGrid<ProductBooksRow, any> {
        protected getColumnsKey() { return ProductBooksColumns.columnsKey; }
        protected getDialogType() { return ProductBooksDialog; }
        protected getIdProperty() { return ProductBooksRow.idProperty; }
        protected getInsertPermission() { return ProductBooksRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductBooksRow.localTextPrefix; }
        protected getService() { return ProductBooksService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}